/**
 * Derives marker visual properties from a school object and metadata maps.
 *
 * @param {Object} school            - school row from API
 * @param {Object} ofstedBySchoolId  - { schoolId: "Outstanding" | "Good" | ... }
 * @returns {Object} { id, name, gender, phase, ofstedGrade, isTopSchool, schoolType }
 */
export function buildMarkerData(school, ofstedBySchoolId = {}) {
  const gender = normaliseGender(school.gender_type);
  const phase = derivePhaseLabel(school.phase);
  const ofstedGrade = ofstedBySchoolId[school.id] || "";
  const isTopSchool = !!school.top_school;
  const schoolType = normaliseSchoolType(school.school_type);

  return {
    id: school.id,
    name: school.name,
    gender,
    phase,
    ofstedGrade,
    isTopSchool,
    schoolType,
  };
}

function normaliseGender(raw) {
  if (!raw) return "Mixed";
  const lower = raw.toLowerCase();
  if (lower === "boys" || lower === "male") return "Boys";
  if (lower === "girls" || lower === "female") return "Girls";
  return "Mixed";
}

function normaliseSchoolType(raw) {
  if (!raw) return "";
  const lower = String(raw).toLowerCase();
  if (lower.includes("grammar")) return "Grammar";
  if (lower.includes("independent") || lower.includes("private")) return "Independent";
  return String(raw);
}

function derivePhaseLabel(raw) {
  if (!raw) return "S";
  const lower = raw.toLowerCase();
  const hasPrimary = lower.includes("primary");
  const hasSecondary = lower.includes("secondary");
  if (
    (hasPrimary && hasSecondary) ||
    lower.includes("all-through") ||
    lower.includes("all through") ||
    lower.includes("all-age") ||
    lower.includes("all age")
  ) {
    return "B"; // both primary + secondary
  }
  if (hasPrimary) return "P";
  if (hasSecondary) return "S";
  if (lower.includes("16") || lower.includes("sixth")) return "6";
  return "S";
}
